// 天津轻工
export default [
  {
    path: "/tj",
    name: "login",
    component: () => import("@/views/tianJin/login")
  }
];



// WEBPACK FOOTER //
// ./src/router/tianJin.js